<template>
  <div>
    <h1>(404) Pagina no encontrada</h1>
  </div>
</template>

<script>
export default {};
</script>